import { render, staticRenderFns } from "./LecturesIndex.vue?vue&type=template&id=20fe70c2"
import script from "./LecturesIndex.vue?vue&type=script&lang=js"
export * from "./LecturesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports